<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="data-list-list-view" class="data-list-container">
		<vs-table ref="table" pagination search :max-items="itemsPerPage" :data="listCompanies">
			<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
				<vs-button
					type="filled"
					class="g-btn-customize p-0 btnCustom"
					icon-pack="feather"
					icon="icon-plus"
					@click.prevent="$emit('valueFormConfigCompany', 1)"
				>
					<span class="btnTextCustom">{{ $t("Crud.Create") + " " + $t("Config") }}</span>
				</vs-button>
			</div>
			<template slot="thead">
				<vs-th
					sort-key="category"
					class="g-table--title"
					v-text="$t('ListCompanyConfig.TypeConfigName')"
				></vs-th>
				<vs-th sort-key="name" class="g-table--title" v-text="$t('CompanyName')"></vs-th>
				<vs-th class="g-table--title" v-text="$t('Action')"></vs-th>
			</template>

			<template slot-scope="{data}">
				<tbody>
					<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
						<vs-td>
							<p class="g-table--description truncate">{{ tr.type_config_name }}</p>
						</vs-td>
						<vs-td>
							<p class="g-table--description">{{ tr.company_name }}</p>
						</vs-td>
						<vs-td class="g-table--description whitespace-no-wrap">
							<feather-icon
								class="g-label--normal"
								icon="Edit2Icon"
								svgClasses="w-5 h-5 hover:text-primary stroke-current"
								@click.stop="editData(tr)"
							/>
							<feather-icon
								icon="Trash2Icon"
								svgClasses="w-5 h-5 hover:text-danger stroke-current"
								class="ml-2 g-label--normal"
								@click.stop="openConfirm(tr.config_company_id)"
							/>
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
	</div>
</template>

<script>
import moduleCompanyConfigCrud from "@/store/company-config-crud/moduleCompanyConfigCrud.js";
import CompanyConf from "@/models/CompanyConf.js";

export default {
	name: "CompanyConfigCrudListView",
	data() {
		return {
			itemsPerPage: 10,
			isMounted: false,
			itemSelected: null,
		};
	},
	computed: {
		currentPage() {
			if (this.isMounted) {
				return this.$refs.table.currentx;
			}
			return 0;
		},
		listCompanies() {
			return this.$store.state.moduleCompanyConfigCrud.companies;
		},
		queriedItems() {
			return this.$refs.table ? this.$refs.table.queriedResults.length : this.listCompanies.length;
		},
	},
	methods: {
		// Pregunta si desea eliminar la configuración de compañia
		openConfirm(id) {
			this.itemSelected = id;
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("DeleteCompanyConf"),
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
				accept: this.acceptAlert,
			});
		},
		// Confirma la eliminación
		acceptAlert() {
			this.deleteData(this.itemSelected);
		},
		// Elimina la configuracion de compañia
		deleteData(id) {
			let payload = {
				config_id: id,
				company_id: this.$route.params.company_id || 0,
			};

			this.$vs.loading();
			this.$store
				.dispatch("moduleCompanyConfigCrud/removeItemConfigCompany", payload)
				.then((res) => {
					this.$vs.loading.close();

					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmCompanyConfigDelete"),
						text: this.$t("TextConfirmCompanyConfigDelete"),
					});
				})
				.catch((err) => {
					this.$vs.loading.close();
					throw new Error(err);
				});
		},
		// Click en editar
		editData(data) {
			this.$emit("selectedCompanyEmit", new CompanyConf(data));
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
	},
	created() {
		// Declara el modulo
		if (!moduleCompanyConfigCrud.isRegistered) {
			this.$store.registerModule("moduleCompanyConfigCrud", moduleCompanyConfigCrud);
			moduleCompanyConfigCrud.isRegistered = true;
		}
	},
	mounted() {
		this.isMounted = true;
	},
};
</script>

<style lang="scss" scoped>
#data-list-list-view {
	.vs-con-table {
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 1.5rem;
			margin-right: 1.5rem;

			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			padding: 0 1rem;

			td {
				font-style: normal;
				font-weight: 300;
				font-size: 12px;
				line-height: 15px;
				color: #666666;
			}
		}

		.vs-table--thead {
			th {
				padding-top: 0;
				padding-bottom: 0;
			}

			th.td-check {
				padding: 0 15px !important;
			}

			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}
</style>
